var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuturo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3542 30.6137C19.2467 30.7935 22.9598 29.4452 25.8478 26.8027C28.7178 24.1781 30.4039 20.5828 30.5833 16.6819C30.7627 12.781 24.0002 14.0034 21.3634 11.1271C18.7445 8.25086 20.5741 1.59953 16.6816 1.43774C12.7892 1.25798 9.07607 2.60622 6.18811 5.24877C3.31808 7.87335 1.63194 11.4687 1.45257 15.3696C1.27319 19.2705 2.61851 22.9916 5.25535 25.8859C7.87425 28.7441 11.4618 30.4339 15.3542 30.6137ZM16.7354 0.0175941C21.0046 0.215336 24.9329 2.06692 27.8209 5.2308C30.7089 8.39467 32.1798 12.4933 31.9824 16.7717C31.7851 21.0502 29.9375 24.987 26.7805 27.8813C23.6235 30.7755 19.5337 32.2496 15.2646 32.0518C10.9954 31.8541 7.06705 30.0025 4.17909 26.8386C1.29113 23.6747 -0.179758 19.5761 0.017556 15.2977C0.21487 11.0192 2.06245 7.08238 5.21947 4.18816C8.39444 1.29393 12.4663 -0.180148 16.7354 0.0175941Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturo);
export default __webpack_public_path__ + "static/media/Futuro.b59eeb4f85becbe583631909a4199f1f.svg";
export { ForwardRef as ReactComponent };